var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundOn = function SvgSoundOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m20.787 28.03.158.132h-.158zm0 0V3.52l-8.522 6.971h-1.736c-.631 0-1.105.162-1.578.649-.473.486-.631.972-.631 1.62v6.161c0 .649.315 1.135.631 1.622.473.324 1.105.648 1.578.648l2.525.324 7.733 6.514Zm2.972-19.698a.623.623 0 0 1 .854-.253c2.78 1.56 4.507 4.533 4.507 7.761 0 3.229-1.727 6.202-4.507 7.76a.624.624 0 0 1-.855-.253.65.65 0 0 1 .248-.871c2.378-1.333 3.856-3.876 3.856-6.636s-1.478-5.303-3.855-6.636a.65.65 0 0 1-.248-.872",
    clipRule: "evenodd"
  })));
};
export default SvgSoundOn;